import { useState } from 'react';
import StartRegistration from './StartRegistration';
import Step1DownloadAuthenticator from './Step1DownloadAuthenticator';
import Step2ScanQRCode from './Step2ScanQRCode';
import Step3ConfirmQRCode from './Step3ConfirmQRCode';
import Step4Mail from './Step4Mail';

let steps = [
    'start-or-skip-registration',
    'start-registration',
    'scan-qr-code',
    'confirm-qr-code',
    'click-on-link-in-email'
]

let stepComponents = [
    StartRegistration,
    Step1DownloadAuthenticator,
    Step2ScanQRCode,
    Step3ConfirmQRCode,
    Step4Mail
]

export default function SecondFactorRegistrationPanel() {

    const [step, setStep] = useState('start-or-skip-registration');
    const [registrationState, _setRegistrationState] = useState({});

    const StepComponent = stepComponents[steps.indexOf(step)];

    const onNext = (registrationState) => {
        let currentStep = steps.indexOf(step);
        let nextStep = (currentStep + 1) % steps.length;
        setStep(steps[nextStep]);
    }


    const onRenew = () => {

    }

    return (
        <StepComponent onRenew={onRenew} onNext={onNext} />
    );
}
